import * as React from "react";

export const JaIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="31"
    height="27"
    viewBox="0 0 31 27"
    fill="none"
    style={{
      position: "absolute",
      zIndex: 1,
      pointerEvents: "none",
      ...props.style
    }}
  >
    <g opacity="0.9">
      <path
        d="M6.17526 21.1298C4.89533 21.1298 3.71513 20.8888 2.64298 20.415C1.57083 19.933 0.689834 19.2431 0 18.3455L2.4352 15.4449C2.94218 16.1347 3.49073 16.65 4.07251 16.9908C4.66261 17.3315 5.28596 17.5061 5.95917 17.5061C7.74609 17.5061 8.80993 16.4672 8.80993 14.3894V5.36333H2.00301V1.83936H13.032V14.14C13.032 16.4921 12.4503 18.2375 11.2867 19.3927C10.1231 20.548 8.4193 21.1298 6.17526 21.1298Z"
        fill="#F8F8F8"
      />
      <path
        d="M10.7803 25.1604L18.7923 7.125H22.9147L31.0016 25.1604H26.6215L19.9975 9.23606H21.668L15.044 25.1604H10.7637H10.7803ZM14.8279 21.2957L15.8834 18.1291H25.2086L26.2891 21.2957H14.8279Z"
        fill="#F8F8F8"
      />
    </g>
  </svg>
);
